
export { DocumentModule } from './document.module';
export { DocumentListComponent } from './document-list.component';
export { DocumentEditComponent } from './document-edit.component';
export { DocumentResolver } from './document.resolver';
export { DocumentsResolver } from './documents.resolver';